import {
  IMember,
  INewUser,
  MemberWithholdingStatus,
  PlatformContextType
} from "@wingspanhq/users/dist/lib/interfaces";
import { components as bankingComponents } from "../../../services/api/banking/types";
import { components as onboardingComponents } from "../../../services/api/onboarding/types";
import { selectorIsBusinessTypeOnePerson } from "../../PaymentsSetup/selectors/selectorIsBusinessTypeOnePerson";
import { selectorCanEnableTaxWithholdings } from "./selectorCanEnableTaxWithholdings";

export const selectorProposeTaxWithholdings = (
  user?: INewUser,
  member?: IMember,
  monitoredEntity?: onboardingComponents["schemas"]["CustomerEntity"],
  internalAccounts?: bankingComponents["schemas"]["InternalAccount"][]
) => {
  if (!user || !member) {
    return false;
  }

  // Don't show a promotion if user already has tax withholding account in any state. It means they already opted-in
  const hasInternalAccount = internalAccounts?.some(
    account => account.type === "TaxWithholding"
  );

  if (hasInternalAccount) {
    return false;
  }

  // Don't show promotions to payers, only payees should see it
  const hasPayeeContext = user.contexts?.some(
    context => context.type === PlatformContextType.Payee
  );

  if (!hasPayeeContext) {
    return false;
  }

  // Don't show promotions to users who can't enable tax withholdings (US only)
  const canEnableTaxWithholdings = selectorCanEnableTaxWithholdings(
    monitoredEntity,
    member
  );

  if (!canEnableTaxWithholdings) {
    return false;
  }

  // Don't show promotions to users who are not single person business
  const companyStructure = member?.profile.company?.structure;
  const isSinglePersonBusiness =
    selectorIsBusinessTypeOnePerson(companyStructure);

  if (!isSinglePersonBusiness) {
    return false;
  }

  // Finally, check if user has tax withholding enabled
  return (
    member?.profile.withholdings?.tax?.status !== MemberWithholdingStatus.Active
  );
};
